import React, { useRef } from 'react';

const FocalPointPicker = ({ imageUrl, focalPoint, onChange, label = 'Focus Point' }) => {
  const containerRef = useRef(null);
  const fp = focalPoint || { x: 50, y: 50 };

  const handleClick = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.round(((e.clientX - rect.left) / rect.width) * 100);
    const y = Math.round(((e.clientY - rect.top) / rect.height) * 100);
    onChange({ x: Math.max(0, Math.min(100, x)), y: Math.max(0, Math.min(100, y)) });
  };

  if (!imageUrl) return null;

  return (
    <div>
      <label className="block text-xs font-medium text-gray-500 mb-1.5">{label}</label>
      <div
        ref={containerRef}
        className="relative w-full cursor-crosshair rounded overflow-hidden border border-gray-200"
        style={{ aspectRatio: '16/9' }}
        onClick={handleClick}
      >
        <img
          src={imageUrl}
          alt="Preview"
          className="w-full h-full object-cover"
          style={{ objectPosition: `${fp.x}% ${fp.y}%` }}
          draggable={false}
        />
        {/* Crosshair indicator */}
        <div
          className="absolute w-5 h-5 border-2 border-white rounded-full shadow-lg pointer-events-none"
          style={{
            left: `${fp.x}%`,
            top: `${fp.y}%`,
            transform: 'translate(-50%, -50%)',
            boxShadow: '0 0 0 1px rgba(0,0,0,0.5), 0 2px 8px rgba(0,0,0,0.3)',
          }}
        >
          <div className="w-1.5 h-1.5 bg-white rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
        </div>
        {/* Crosshair lines */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute bg-white/30" style={{ left: `${fp.x}%`, top: 0, width: '1px', height: '100%' }} />
          <div className="absolute bg-white/30" style={{ top: `${fp.y}%`, left: 0, height: '1px', width: '100%' }} />
        </div>
      </div>
      <p className="text-[10px] text-gray-400 mt-1">Click to set focus point ({fp.x}%, {fp.y}%)</p>
    </div>
  );
};

export default FocalPointPicker;
